import React, { useState } from "react";
import { Card, Dropdown } from "react-bootstrap";
import { FiCalendar } from "react-icons/fi";

export default function WonDealsStagCard() {
  const [filter, setFilter] = useState("This Week");

  const dataMap = {
    "This Week": { value: "45,899.79", percent: 12 },
    "Last Week": { value: "35,200.10", percent: 8 },
    "This Month": { value: "60,500.50", percent: 15 },
  };

  return (
    <Card className="flex-fill won-stage-card">
      
      {/* Header */}
      <Card.Header className="d-flex justify-content-between card-header-custom align-items-center">
        <h5 className="mb-0">Won Deals Stage</h5>

        <Dropdown>
          <Dropdown.Toggle className="won-stage-toggle text-dark">
            <FiCalendar className="me-1" />
            {filter}
          </Dropdown.Toggle>

          <Dropdown.Menu align="end" className="won-stage-menu">
            {["This Month", "This Week", "Last Week"].map((item) => (
              <Dropdown.Item
                key={item}
                active={filter === item}
                onClick={() => setFilter(item)}
                className="won-stage-item"
              >
                {item}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </Card.Header>

      {/* Body */}
      <Card.Body className="text-center">
        <p className="mb-1 won-stage-subtitle">Stages Won This Year</p>

        <div className="d-flex justify-content-center align-items-center mb-3">
          <h3 className="me-2">${dataMap[filter].value}</h3>

          <span className="won-stage-badge">
            ↓ {dataMap[filter].percent}%
          </span>
        </div>

        {/* Circles */}
        <div className="won-stage-wrapper">
          <div className="won-stage-circle won-stage-big won-stage-dark">
            <span>Conversion</span>
            <h6>48%</h6>
          </div>

          <div className="won-stage-circle won-stage-small won-stage-red">
            <span>Calls</span>
            <h6>24%</h6>
          </div>

          <div className="won-stage-circle won-stage-small won-stage-yellow">
            <span>Email</span>
            <h6>39%</h6>
          </div>

          <div className="won-stage-circle won-stage-small won-stage-green">
            <span>Chats</span>
            <h6>20%</h6>
          </div>
        </div>
      </Card.Body>

      {/* CSS */}
      <style>{`
        /* CARD */
        .won-stage-card {
          border-radius: 5px;
          border: 2px solid #e5e7eb;
        }

      .card-header-custom{
display:flex;
justify-content:space-between;
align-items:center;
padding:18px;
border-bottom:1px solid #eee;
background:#ffffff;


}

.card-header-custom h5{
margin:0;
font-size:18px;
font-weight:600;
color:#1f2937;
}

        /* DROPDOWN BUTTON */
        .won-stage-toggle {
          background: #fff !important;
          border: 1px solid #e5e7eb !important;
          font-size: 14px;
          border-radius: 8px;
          padding: 6px 12px;
        }

        .won-stage-toggle::after {
          display: none !important;
        }

        .won-stage-toggle:hover,
        .won-stage-toggle:focus,
        .won-stage-toggle:active,
        .won-stage-toggle.show {
          border-color: #ff6a2c !important;
          color: #ff6a2c !important;
          box-shadow: none !important;
        }

        /* DROPDOWN MENU */
        .won-stage-menu {
          border-radius: 8px;
          padding: 6px;
        }

        .won-stage-item {
          border-radius: 6px;
          font-size: 14px;
        }

        .won-stage-item.active,
        .won-stage-item:active {
          background: #ff6a2c !important;
          color: #fff !important;
        }

        .won-stage-item:hover {
          background: #fff4ed;
          color: #ff6a2c;
        }

        /* TEXT */
        .won-stage-subtitle {
          color: #6b7280;
          font-size: 14px;
        }

        /* BADGE */
        .won-stage-badge {
          background: #fff1f2;
          color: #dc2626;
          border: 1px solid #fecaca;
          padding: 4px 8px;
          border-radius: 6px;
          font-size: 12px;
        }

        /* CIRCLES */
        .won-stage-wrapper {
          position: relative;
          height: 220px;
        }

        .won-stage-circle {
          position: absolute;
          border-radius: 50%;
          color: #fff;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        }

        .won-stage-big {
          width: 150px;
          height: 150px;
          left: 20%;
        }

        .won-stage-small {
          width: 90px;
          height: 90px;
        }

        /* COLORS */
        .won-stage-dark {
          background: #123d4a;
        }

        .won-stage-red {
          background: #ff3b30;
          top: 0;
          left: 55%;
        }

        .won-stage-yellow {
          background: #ffc107;
          top: 40%;
          left: 60%;
        }

        .won-stage-green {
          background: #22c55e;
          bottom: 0;
          left: 45%;
        }

        /* RESPONSIVE */
        @media (max-width: 1024px) {
          .won-stage-card {
            margin-top: 15px;
          }
        }
      `}</style>
    </Card>
  );
}